import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  @Input() id: string;
  @Input() label: string;
  @Input() name: string;
  @Input() value: boolean;
  @Output() valueChange = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
  }

}
